'use strict'

export const CASES = {}
